import { render } from "./pageLayout.vue?vue&type=template&id=ad6d2534&scoped=true"
import script from "./pageLayout.vue?vue&type=script&lang=js"
export * from "./pageLayout.vue?vue&type=script&lang=js"

import "./pageLayout.vue?vue&type=style&index=0&id=ad6d2534&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad6d2534"]])

export default __exports__